// Browser polyfill for node-fetch - uses native fetch
// This file is used to replace node-fetch in browser builds

const nodeFetch = globalThis.fetch;

// Export default and named exports to match node-fetch API
module.exports = nodeFetch;
module.exports.default = nodeFetch;

// Re-export browser globals that node-fetch would normally provide
module.exports.Headers = globalThis.Headers;
module.exports.Request = globalThis.Request;
module.exports.Response = globalThis.Response;

// AbortError for compatibility
class AbortError extends Error {
	constructor(message) {
		super(message);
		this.name = 'AbortError';
		this.type = 'aborted';
	}
}
module.exports.AbortError = AbortError;

// FetchError for compatibility
class FetchError extends Error {
	constructor(message, type, systemError) {
		super(message);
		this.name = 'FetchError';
		this.type = type;
		if (systemError) {
			this.code = systemError.code;
			this.errno = systemError.errno;
		}
	}
}
module.exports.FetchError = FetchError;

// Blob - use native
module.exports.Blob = globalThis.Blob;

// blobFrom, blobFromSync, fileFrom, fileFromSync - not available in browser
module.exports.blobFrom = () => {
	throw new Error('blobFrom is not supported in browser');
};
module.exports.blobFromSync = () => {
	throw new Error('blobFromSync is not supported in browser');
};
module.exports.fileFrom = () => {
	throw new Error('fileFrom is not supported in browser');
};
module.exports.fileFromSync = () => {
	throw new Error('fileFromSync is not supported in browser');
};

// isRedirect helper
module.exports.isRedirect = (code) => {
	return (
		code === 301 || code === 302 || code === 303 || code === 307 || code === 308
	);
};
